import {
  Box,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tabs
} from "@mui/material";
import React, { useState } from "react";
import AvatarImg from "../../../Assets/images/icons/user.png";
import { notFound } from "../../../enums/mainEnums";
import ContactData from "./contact-data";
import Reviews from "./reviews";
import IPs from "./IPs";
import {Link} from "react-router-dom";
import {FaEye} from "react-icons/fa";

const UserDetailsPage = ({ data }) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {
        <div className={`flex flex-col items-start`}>
          <div className="flex gap-12">
            <div className="user-data">
              <div className="flex flex-col items-start">
                <div className="user-name font-bold">{data?.name}</div>
                <div className="user-email font-bold mb-4">{data?.subject}</div>
                <div className="user-details flex gap-10">
                  <div className="user-created-at flex flex-col items-start">
                    <div>Total Recipients</div>
                    <div className="font-bold">{data?.total_recipients}</div>{" "}
                  </div>
                  <div className="user-created-at flex flex-col items-start">
                    <div>Sent Count</div>
                    <div className="font-bold">{data?.sent_count}</div>
                  </div>
                  <div className="user-created-at flex flex-col items-start">
                    <div>Opend Count</div>
                    <div className="font-bold">{data?.open_count}</div>
                  </div>
                  <div className="user-created-at flex flex-col items-start">
                    <div>Clicked Count</div>
                    <div className="font-bold">{data?.click_count}</div>
                  </div>
                  <div className="user-created-at flex flex-col items-start">
                    <div>Failed Count</div>
                    <div className="font-bold">{data?.failed_count}</div>
                  </div>
                  <div className="user-created-at flex flex-col items-start">
                    <div>Started At</div>
                    <div className="font-bold">{data?.started_at}</div>
                  </div>
                  <div className="user-created-at flex flex-col items-start">
                    <div>Completed At</div>
                    <div className="font-bold">{data?.completed_at}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*<div className="description">*/}
          {/*  {data?.sex !== notFound && <div>sex: {data?.sex}</div>}*/}
          {/*  {data?.about !== notFound && <div>about: {data?.about}</div>}*/}
          {/*  {data?.description !== notFound && (*/}
          {/*    <div>description: {data?.description}</div>*/}
          {/*  )}*/}
          {/*</div>*/}
          <Box
            sx={{
              borderBottom: 1,
              marginTop: "20px",
              borderColor: "divider",
              width: "100%",
            }}
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow className="bg-primary">
                    {["id", "Email", "subject", "status", "sent_at", "opened_at", "clicked_at", "created_at"].map((column) => (
                        <TableCell
                            key={column}
                            align="center"
                            className="!text-darkTextColor whitespace-nowrap"
                        >
                          <TableSortLabel
                          >
                            {column === "email_verified_at" ? "Verify at" : column}
                          </TableSortLabel>
                        </TableCell>
                    ))}
                    <TableCell
                        align="center"
                        className="!text-darkTextColor whitespace-nowrap"
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.sentEmails.map((item) => {
                    return (
                        <TableRow
                            key={item.id}
                            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                            hover
                        >
                          {/*<TableCell padding="checkbox">*/}
                          {/*  <Checkbox*/}
                          {/*      color="primary"*/}
                          {/*      checked={isItemSelected}*/}
                          {/*      onChange={(event) => handleSelect(event, item.id)}*/}
                          {/*  />*/}
                          {/*</TableCell>*/}
                          <TableCell component="th" scope="row" align="center">
                            {item?.id}
                          </TableCell>
                          <TableCell align="center">{item?.email}</TableCell>
                          <TableCell align="center">{item?.subject}</TableCell>
                          <TableCell align="center">
                    <span
                        className={`badge w-24 text-darkTextColor ${
                            item?.status === 'sent'
                                ? "bg-[#28a745]"
                                : "bg-[#ff6877]"
                        }`}
                    >
                      {item?.status}
                    </span>
                          </TableCell>
                          <TableCell align="center">{item?.sent_at}</TableCell>
                          <TableCell align="center">{item?.opened_at}</TableCell>
                          <TableCell align="center">{item?.clicked_at}</TableCell>
                          <TableCell align="center">{item?.created_at}</TableCell>
                          <TableCell align="center">
                            <div className="flex gap-x-10 text-lg items-center justify-center">
                              <Link
                                  to={`/UserCampaigns/Email/${item?.id}`}
                                  color="inherit"
                                  underline="none"
                                  className="flex items-center justify-center"
                              >
                                <FaEye className="text-[#6c757d]" />
                              </Link>
                            </div>
                          </TableCell>
                        </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      }
    </>
  );
};

export default UserDetailsPage;
